import {Router} from "@/rawdogjs/src/router";
import {ApiClientBase} from "./WebApiClientBase";
import {ParcelWebHttpClient} from "./ParcelWebHttpClient";
import {AuthenticationManager} from "./AuthenticationManager";

export class BookingApi extends ApiClientBase {

    constructor(
        router: Router,
        httpClient: ParcelWebHttpClient,
        authenticationManager: AuthenticationManager,
        url: string
    ) {
        super(
            '/api/bookings',
            router,
            httpClient,
            authenticationManager,
            url
        );
    }

}